import React from 'react';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import Config from '../../../config/Config';
import { googleSignInClientID } from '../../../utils/secretKeys';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
	setSocialLoginUserDetails,
	onSocialLogin,
} from '../../../redux/userAuthentication/userAuth.actions';

const { ASSETSPATH } = Config;

class SocialLogin extends React.Component {
	constructor(props) {
		super(props);
		this.onGoogleSuccess = this.onGoogleSuccess.bind(this);
		this.onFbSuccess = this.onFbSuccess.bind(this);
	}
	onGoogleSuccess = async (response) => {
		if (response.googleId) {
			let {
				profileObj: { email, name, imageUrl },
				accessToken,
			} = response;
			let data = {
				loginId: email,
				userToken: accessToken,
				userName: name,
				photoUrl: imageUrl,
				socialDomain: 'google',
			};
			await this.props.setSocialLoginParams(data);
			this.props.onLoginSuccess();
		}
	};
	onFbSuccess = async (response) => {
		if (response.accessToken) {
			let {
				email,
				id,
				accessToken,
				name,
				picture: {
					data: { url },
				},
			} = response;
			let data = {
				loginId: email ? email : id + '@facebook.com',
				userToken: accessToken,
				userName: name,
				photoUrl: url,
				socialDomain: 'fb',
			};
			await this.props.setSocialLoginParams(data);
			this.props.onLoginSuccess();
		}
	};

	render() {
		return (
			<div>
				<div className="login-orlabel text-center">or</div>
				<div className="login-social-link text-center">
					<GoogleLogin
						aria-label="signin-with-gmail"
						clientId={googleSignInClientID}
						onSuccess={this.onGoogleSuccess}
						onFailure={this.onGoogleSuccess}
						className="step-gplus-link"
						buttonText=""
					></GoogleLogin>
					<FacebookLogin
						aria-label="signin-with-facebook"
						appId="1919050234989715"
						fields="name,email,picture"
						scope="public_profile,email"
						callback={this.onFbSuccess}
						cssClass="step-fb-link"
						textButton={<img src={ASSETSPATH + 'img/fb-login.png'} alt="Facebook" />}
					/>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		setSocialLoginParams: (event) => dispatch(setSocialLoginUserDetails(event)),
		onLoginSuccess: () => dispatch(onSocialLogin()),
	};
};

export default compose(connect(null, mapDispatchToProps))(SocialLogin);
